import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPhonePausedComponent } from "./med-icon-phone-paused.component";

@NgModule({
  declarations: [
    MedIconPhonePausedComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPhonePausedComponent,
  ],
})
export class MedIconPhonePausedModule { }
